var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('h1',{staticClass:"black--text text-center"},[_vm._v("Manage Reservations")])])
}
var staticRenderFns = []

export { render, staticRenderFns }